import _ from 'lodash';
import { store } from '_/vuex/store';
import { redactorConfig } from '~/components/FieldTypes/Redactor/Redactor.config';

export const imageTagTemplate = function imageTagTemplate(asset, tempId) {
    let defaultLocale = store.state.ui.defaultLocale.languageCode;

    // Get title from the fields.title object with proper locale handling
    // If it's a string (from direct input), use it directly
    let title = '';
    if (typeof asset.fields.title === 'string') {
        title = asset.fields.title;
    } else if (asset.fields.title && asset.fields.title[defaultLocale]) {
        title = asset.fields.title[defaultLocale];
    }

    const source = !_.isEmpty(asset.fields.source) ? asset.fields.source.anchor_text : '';

    const link = !_.isEmpty(asset.fields.link) ? asset.fields.link.anchor_text : '';

    const imageSizeId = asset.imageSizeId ? asset.imageSizeId : redactorConfig.defaultImageSizeId;

    const imageAlignment = asset.imageAlignment ? asset.imageAlignment : redactorConfig.defaultImageAlignment;

    // Since image sizes concept was removed, always use the original image
    let imageUrl = asset.fields.file_url;

    const resizedImage = imageUrl;

    let html = `<div class="${imageAlignment}">`;

    if (link !== '') {
        html += `<a href="${link}" target="_blank">`;
    }
    html += `<img src="${resizedImage}" id="${tempId}" alt="${title}" data-image-alignment="${imageAlignment}" data-image-size-id="${imageSizeId}" data-asset-id="${asset.system.id}">`;

    if (source !== '') {
        html += `<span class="source">${source}</span>`;
    }

    if (link !== '') {
        html += `</a>`;
    }
    html += `</div>`;

    return html;
};
